import { render } from "./CategoryProductListModal.vue?vue&type=template&id=bacf9e46"
import script from "./CategoryProductListModal.vue?vue&type=script&lang=js"
export * from "./CategoryProductListModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__